import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Tag } from 'primereact/tag'
import { mockClients, mockContracts, mockProjects, mockSubscriptions } from '../../../mocks'
import { contractStatusLabel, contractStatusSeverity } from '../../Contracts/utils/contractHelpers'
import { projectStatusLabel, projectStatusSeverity } from '../../Projects/utils/projectHelpers'

const ClientDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const client = mockClients.find((c) => c.id === id)
  if (!client) {
    return (
      <div>
        <Button icon='pi pi-arrow-left' text label='Voltar' onClick={() => navigate(-1)} />
        <p>Cliente não encontrado.</p>
      </div>
    )
  }

  const contracts = mockContracts.filter((c) => c.clientId === id)
  const projects = mockProjects.filter((p) => p.clientId === id)
  const subscription = mockSubscriptions.find((s) => s.clientId === id)

  return (
    <div style={{ maxWidth: 900 }}>
      <Button
        icon='pi pi-arrow-left'
        text
        label='Voltar para Clientes'
        onClick={() => navigate('/dashboard/clientes')}
        style={{ marginBottom: '1.5rem' }}
      />

      {/* Header */}
      <Card style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
          <div>
            <h2 style={{ margin: '0 0 0.5rem' }}>{client.name}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', color: 'var(--text-color-secondary)' }}>
              <span><i className='pi pi-envelope' style={{ marginRight: '0.5rem' }} />{client.email}</span>
              <span><i className='pi pi-phone' style={{ marginRight: '0.5rem' }} />{client.phone}</span>
              <span><i className='pi pi-map-marker' style={{ marginRight: '0.5rem' }} />{client.city} – {client.state}</span>
              {client.cnpj && <span><i className='pi pi-id-card' style={{ marginRight: '0.5rem' }} />CNPJ: {client.cnpj}</span>}
              <span><i className='pi pi-calendar' style={{ marginRight: '0.5rem' }} />
                Cliente desde {new Date(client.createdAt).toLocaleDateString('pt-BR')}
              </span>
            </div>
          </div>
          {subscription && (
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-color-secondary)', marginBottom: '0.25rem' }}>Assinatura</div>
              <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>{subscription.planName}</div>
              <div style={{ color: 'var(--primary-color)', fontWeight: 600 }}>
                R$ {subscription.monthlyPrice.toLocaleString('pt-BR')}/mês
              </div>
            </div>
          )}
        </div>
      </Card>

      {/* Projects */}
      <Card title='Aplicativos' style={{ marginBottom: '1.5rem' }}>
        {projects.length === 0 ? (
          <p style={{ color: 'var(--text-color-secondary)' }}>Nenhum aplicativo cadastrado.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {projects.map((p) => (
              <div
                key={p.id}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: 8, background: 'var(--surface-ground)', cursor: 'pointer' }}
                onClick={() => navigate(`/dashboard/aplicativos/${p.id}`)}
              >
                <div>
                  <div style={{ fontWeight: 600 }}>{p.name}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--text-color-secondary)' }}>{p.hosting}</div>
                </div>
                <Tag value={projectStatusLabel(p.status)} severity={projectStatusSeverity(p.status)} />
              </div>
            ))}
          </div>
        )}
      </Card>

      {/* Contracts */}
      <Card title='Contratos'>
        {contracts.length === 0 ? (
          <p style={{ color: 'var(--text-color-secondary)' }}>Nenhum contrato cadastrado.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {contracts.map((c) => (
              <div
                key={c.id}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem', borderRadius: 8, background: 'var(--surface-ground)', cursor: 'pointer' }}
                onClick={() => navigate(`/dashboard/contratos/${c.id}`)}
              >
                <div>
                  <div style={{ fontWeight: 600 }}>{c.title}</div>
                  <div style={{ fontSize: '0.82rem', color: 'var(--text-color-secondary)' }}>
                    {new Date(c.startDate).toLocaleDateString('pt-BR')} até {new Date(c.endDate).toLocaleDateString('pt-BR')}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <span style={{ fontWeight: 600 }}>R$ {c.monthlyFee.toLocaleString('pt-BR')}/mês</span>
                  <Tag value={contractStatusLabel(c.status)} severity={contractStatusSeverity(c.status)} />
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  )
}

export default ClientDetailPage
